import { gql } from '@apollo/client';
import classNames from 'classnames/bind';
import { Container, RichText } from '@/components';
import styles from './DisclosureBlock.module.scss';
let cx = classNames.bind(styles);

export function DisclosureBlock({ disclosures }) {
	return (
		<section className={cx(['ns_disclosures', 'disclosures'])}>
			<Container>
				{disclosures?.disclosures && <RichText html={disclosures.disclosures} />}
				{!disclosures?.removeGlobalDisclosures && (
					<div className={cx('ns_gloabl-disclosures')}>
						<p>The Netspend&reg; Visa&reg; Prepaid Card is issued by Pathward&reg;, National Association, or Republic Bank & Trust Company; Member FDIC, pursuant to a license from Visa U.S.A. Inc. The Netspend&reg; Prepaid Mastercard&reg; is issued by Pathward, N.A., Republic Bank & Trust Company, or The Bancorp Bank, N.A.; Member FDIC, pursuant to license by Mastercard International Incorporated. The Netspend&reg; Debit Account is a deposit account established by Pathward, N.A., or Republic Bank & Trust Company. Please see the back of your Card for its issuing bank. Ouro Global, Inc. is a registered agent of and service provider to Pathward, N.A., Republic Bank & Trust Company, and The Bancorp Bank, N.A. The Netspend&reg; Visa&reg; Prepaid Card can be used everywhere Visa debit cards are accepted. The Netspend&reg; Prepaid Mastercard&reg; can be used everywhere Debit Mastercard is accepted. Use of the Card Account is subject to activation, ID verification, and funds availability. Transaction fees, terms, and conditions apply to the use and reloading of the Card Account.  See the Cardholder Agreement for details.</p>
						<p>Mastercard and the circles design are registered trademarks of Mastercard International Incorporated.</p>
						<p>Google Play and the Google Play logo are trademarks of Google LLC.</p>
						<p>Apple&reg; and the Apple logo&reg; are trademarks of Apple Inc., registered in the U.S. and other countries. The App Store&reg; is a registered service mark of Apple Inc.</p>
					</div>
				)}
			</Container>
		</section>
	);
}

DisclosureBlock.fragments = {
	entry: gql`
		fragment PageDisclosuresFragment on Disclosures {
			disclosures
			removeGlobalDisclosures
		}
	`,
};
